import React from 'react';

export const WhatsAppButton: React.FC = () => {
  const handleClick = () => {
    window.open('https://wa.me/905443953935', '_blank');
  };

  return (
    <button
      onClick={handleClick}
      className="fixed bottom-6 right-6 w-16 h-16 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300 z-50 cursor-pointer animate-pulse"
      aria-label="WhatsApp ile iletişime geç"
    >
      <i className="ri-whatsapp-line text-white text-3xl"></i>
    </button>
  );
};